import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import theme from 'src/darkTheme';

interface ButtonCTAOnboardingProps extends Omit<ButtonProps, 'children'> {
  label: string;
  onClick: () => void;
}

const ButtonCTAOnboarding: React.FC<ButtonCTAOnboardingProps> = ({
  label,
  onClick,
  ...props
}) => {
  return (
    <Button
      component="button"
      onClick={onClick}
      sx={{
        backgroundColor: '#4949C8',
        borderRadius: 2,
        fontSize: 16,
        fontWeight: 400,
        width: '100%',
        p: 2,
        textAlign: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
          transition: 'background-color 0.3s ease',
          backgroundColor: '#3535a8',
          textDecoration: 'none',
        },
        color: theme.palette.common.white,
        boxShadow: 'none',
      }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default ButtonCTAOnboarding;
